import { createAction } from '@reduxjs/toolkit';
import type { CustomerPrivacyConfig, RoleAccessConfig } from 'types';

// eslint-disable-next-line import/prefer-default-export
export const updatePermissionsPolicy = createAction<{
  privacyConfig: CustomerPrivacyConfig;
  roleAccessConfig: RoleAccessConfig;
}>('PERMISSIONS/UPDATE_POLICY');
